import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../Common/Configurations/AuthContext';
import Header from '../../../Common/Layout/Header';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import countries from '../../../Data/Countries.json';
import moment from 'moment';
import config from '../../../Common/Configurations/APIConfig';
import apiService from "../../../Common/Configurations/APIService";
import DefaultData from '../../../CompanyData/DefaultData';
import styles from './FlightDetails2.module.css';
const FlightDetails2 = ({ mode, onNavigate, templateId, params: builderParams, styleConfig, companyId }) => {
    const urlParams = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { user, loading } = useAuth();
    const finalCompanyId = (mode === "builder" || mode === "preview")
        ? (user?.isSupplierAPI === true ? user?.cid : user?.parentCompanyId)
        : companyId;

    // DYNAMIC CSS VARIABLES
    const themeVariables = {
        "--primary-color": styleConfig?.primary || "#c9a84c",
        "--secondary-color": styleConfig?.secondary || "#e8cc7a",
    };

    // Safely grab data for Builder vs Live modes
    const params = builderParams || urlParams;
    const p_adults = parseInt(params?.adults || 1);
    const p_kids = parseInt(params?.kids || 0);
    const p_infants = parseInt(params?.infants || 0);
    const p_isDomestic = params?.isDomestic || 'DOMESTIC';
   const pageState = mode === "builder" ? builderParams : state;
    const [minDate, setMinDate] = useState('');
    const[errors, setErrors] = useState({});
    const [passportErrors, setPassportErrors] = useState({});
    const [btnLoading, setBtnLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState({});
    const [itinerary, setItinerary] = useState([]);
    const[legs, setLegs] = useState([]);
    const [adultTravellers, setAdultTravellers] = useState([]);
    const [kidTravellers, setKidTravellers] = useState([]);
    const[infantTravellers, setInfantTravellers] = useState([]);
    const [totalTravellers, setTotalTravellers] = useState(0);
    const [discount, setDiscount] = useState(0);
    const[baseFare, setBaseFare] = useState(0);
    const [tax, setTax] = useState(0);
    const [totalFare, setTotalFare] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [convenienceFee, setConvenienceFee] = useState(0);
    const [email, setEmail] = useState(user?.email || '');
    const [mobile, setMobile] = useState(user?.phoneNumber || '');
    const [paymentGatewayFee, setPaymentGatewayFee] = useState(0);
    const [paymentGatewayAmount, setPaymentGatewayAmount] = useState(0);
    const [companyGST, setCompanyGST] = useState(user?.companygstno || '');
    const [companyName, setCompanyName] = useState(user?.companyname || '');
    const [companyAddress, setCompanyAddress] = useState(user?.companyaddress || '');
    const [bookingStatus, setBookingStatus] = useState('');

    // Modal states
    const[showBookingModal, setShowBookingModal] = useState(false);
    const[showFlightModal, setShowFlightModal] = useState(false);
    const [selectedFlightDetails, setSelectedFlightDetails] = useState(null);
    const [activeTab, setActiveTab] = useState({});

    // 👇 FIXED: Added missing email and mobile handlers
    const handleEmailChange = (e) => setEmail(e.target.value);
    const handleMobileChange = (e) => setMobile(e.target.value);

    const handleTabClick = (modalId, tabId) => {
        setActiveTab(prev => ({ ...prev, [modalId]: tabId }));
    };

    const handleShowFlightDetails = (flightData, legData, idx, index) => {
        setSelectedFlightDetails({
            itinerary: flightData,
            leg: legData,
            modalId: `flight-${idx}-${index}`,
            idx: idx,
            index: index
        });
        setShowFlightModal(true);
    };

    function getformtravelData(tData) {
        var gender = "MALE";
        if (tData.title === "Mr" || tData.title === "Master") {
            gender = "MALE";
        } else if (tData.title === "Mrs" || tData.title === "Ms") {
            gender = "FEMALE";
        }

        return {
            travelerId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            firstName: tData.firstName,
            lastName: tData.lastName,
            title: tData.title,
            gender: gender,
            travelerType: tData.type,
            dateOfBirth: p_isDomestic === 'INTERNATIONAL' ? moment(tData.dateOfBirth).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
            passportNo: tData.passportNo,
            passportNationality: tData.passportNationality,
            passbookIssueDate: p_isDomestic === 'INTERNATIONAL' ? moment(tData.passbookIssueDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
            passbookExpireDate: p_isDomestic === 'INTERNATIONAL' ? moment(tData.passbookExpireDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
        };
    }

    const validate = (index, adata) => {
        let temp = {};
        temp.firstName = adata.firstName === "" ? false : true;
        temp.lastName = adata.lastName === "" ? false : true;
        if (p_isDomestic === 'INTERNATIONAL') {
            temp.dateOfBirth = adata.dateOfBirth === "" ? false : true;
            temp.passportNo = adata.passportNo === "" ? false : true;
            temp.passportNationality = adata.passportNationality === "" ? false : true;
            temp.passbookIssueDate = adata.passbookIssueDate === "" ? false : true;
            temp.passbookExpireDate = adata.passbookExpireDate === "" ? false : true;
        }
        temp.email = email === "" ? false : true;
        temp.mobile = mobile === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };

    const [errorAdult, setAdultError] = useState('');
    const [errorKid, setKidError] = useState('');
    const [errorInfant, setInfantError] = useState('');

    const validateAdultDate = (index, event) => {
        const inputDate = new Date(event.target.value);
        const year = inputDate.getFullYear().toString();
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 100;
        if (year.length > 4 && event.target.value) {
            setAdultError('The year must be 4 digits!');
            event.target.value = '';
        } else if (year < minYear || year > currentYear) {
            setAdultError(`The year must be between ${minYear} and ${currentYear}!`);
            event.target.setCustomValidity(`The year must be between ${minYear} and ${currentYear}`);
            event.target.value = '';
        } else {
            const values =[...adultTravellers];
            values[index][event.target.name] = event.target.value;
            setAdultTravellers(values);
            setAdultError('');
        }
    };

    const validateKidsDate = (index, event) => {
        const inputDate = new Date(event.target.value);
        const year = inputDate.getFullYear().toString();
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 12;
        if (year.length > 4 && event.target.value) {
            setKidError('The year must be 4 digits!');
            event.target.value = '';
        } else if (year < minYear || year > currentYear) {
            setKidError(`The year must be between ${minYear} and ${currentYear}!`);
            event.target.setCustomValidity(`The year must be between ${minYear} and ${currentYear}`);
            event.target.value = '';
        } else {
            const values = [...kidTravellers];
            values[index][event.target.name] = event.target.value;
            setKidTravellers(values);
            setKidError('');
        }
    };

    const validateInfantDate = (index, event) => {
        const inputDate = new Date(event.target.value);
        const year = inputDate.getFullYear().toString();
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 2;
        if (year.length > 4 && event.target.value) {
            setInfantError('The year must be 4 digits!');
            event.target.value = '';
        } else if (year < minYear || year > currentYear) {
            setInfantError(`The year must be between ${minYear} and ${currentYear}!`);
            event.target.setCustomValidity(`The year must be between ${minYear} and ${currentYear}`);
            event.target.value = '';
        } else {
            const values = [...infantTravellers];
            values[index][event.target.name] = event.target.value;
            setInfantTravellers(values);
            setInfantError('');
        }
    };

    const handleAdultChange = (index, event) => {
        const values = [...adultTravellers];
        values[index][event.target.name] = event.target.value;
        setAdultTravellers(values);
    };

    const handleKidsChange = (index, event) => {
        const values = [...kidTravellers];
        values[index][event.target.name] = event.target.value;
        setKidTravellers(values);
    };

    const handleInfantChange = (index, event) => {
        const values =[...infantTravellers];
        values[index][event.target.name] = event.target.value;
        setInfantTravellers(values);
    };

    const validatePassportDates = (travellerType, index, event) => {
        const { name, value } = event.target;
        const today = new Date();
        const inputDate = new Date(value);
        let values;

        if (travellerType === "adult") values = [...adultTravellers];
        if (travellerType === "kid") values =[...kidTravellers];
        if (travellerType === "infant") values = [...infantTravellers];

        let errorsList = { ...passportErrors };
        const errorKey = `${travellerType}_${index}_${name}`;

        if (name === "passbookIssueDate") {
            if (inputDate > today) {
                errorsList[errorKey] = "Passport issue date cannot be greater than today's date!";
                values[index][name] = "";
                setPassportErrors(errorsList);
                updateTravellersState(travellerType, values);
                return;
            } else {
                errorsList[errorKey] = "";
            }
        }

        if (name === "passbookExpireDate") {
            const minExpiry = new Date();
            minExpiry.setMonth(minExpiry.getMonth() + 6);

            if (inputDate <= minExpiry) {
                errorsList[errorKey] = "Passport expiry date must be at least 6 months from today!";
                values[index][name] = "";
                setPassportErrors(errorsList);
                updateTravellersState(travellerType, values);
                return;
            } else {
                errorsList[errorKey] = "";
            }
        }

        values[index][name] = value;
        updateTravellersState(travellerType, values);
        setPassportErrors(errorsList);
    };

    const updateTravellersState = (type, values) => {
        if (type === "adult") setAdultTravellers(values);
        if (type === "kid") setKidTravellers(values);
        if (type === "infant") setInfantTravellers(values);
    };

   const handleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    var temptravellerinfos = [];

    // 1. Validate and gather traveler data
    for (var i = 0; i < adultTravellers.length; i++) {
        if (validate(i, adultTravellers[i])) {
            temptravellerinfos.push(getformtravelData(adultTravellers[i]));
        }
    }
    for (var i = 0; i < kidTravellers.length; i++) {
        if (validate(i, kidTravellers[i])) {
            temptravellerinfos.push(getformtravelData(kidTravellers[i]));
        }
    }
    for (var i = 0; i < infantTravellers.length; i++) {
        if (validate(i, infantTravellers[i])) {
            temptravellerinfos.push(getformtravelData(infantTravellers[i]));
        }
    }

    // 2. Check for date/validation errors
    if (errorAdult !== "" || errorKid !== "" || errorInfant !== "") {
        alert("Please check the errors");
        setBtnLoading(false);
        return;
    }

    // 3. Check if all travelers are filled correctly
    if (temptravellerinfos.length === totalTravellers) {

            // 🚀 BUILDER & PREVIEW MODE
           if (mode === "builder" || mode === "preview") {
                setTimeout(() => {
                    const flightBookingResponse = {
                        status: true,
                        message: "Simulated Success",
                        travellerInfos: temptravellerinfos,
                        dcFlightLegs: legs,
                        baseFare, tax, totalFare, totalPrice, convenienceFee, paymentGatewayAmount,
                        flightSearchRequest: searchQuery
                    };
                    setBtnLoading(false);
                    if (mode === "builder") onNavigate({ name: "flight-review", params: { flightBookingResponse } });
                    else navigate(`/template-preview/${templateId}/flight-review`, { state: { flightBookingResponse } });
                }, 1500);
                return;
            }


            // 🚀 LIVE MODE (Real API Logic)
            const flightBookingRequest = {
                flightBookingId: "00000000-0000-0000-0000-000000000000",
                userId: user?.id || null, // Guest safe
                branchId: user?.bid || null,
                bookingNo: '',
                pnr: '',
                isDomestic: p_isDomestic,
                isHold: false,
                supplierId: itinerary[0]?.fare?.supplierId,
                travellerInfos: temptravellerinfos,
                dcFlightLegs: legs,
                dcPriceDetails: itinerary.flatMap(item => item.fare),
                flightSearchRequest: searchQuery,
                baseFare: baseFare,
                tax: tax,
                totalFare: totalFare,
                totalPrice: totalPrice,
                convenienceFee: convenienceFee,
                gst: 0,
                gstAmount: 0,
                discount: discount,
                markup: 0,
                couponCode: '',
                email: email,
                mobile: mobile,
                transactionNo: '',
                paymentGatewayNo: '',
                paymentGatewayFee: 0,
                paymentGateway: 'DIRECT',
                paymentStatus: 'PENDING',
                bookingStatus: bookingStatus,
                paymentGatewayAmount: paymentGatewayAmount,
                companyGST: companyGST === '' ? user?.companygstno : companyGST,
                companyName: companyName === '' ? user?.companyname : companyName,
                companyAddress: companyAddress,
                requestedBy: "CUSTOMER"
            };

            try {
                var flightBookingResponse = await apiService.post(config.REVIEWHFLIGHT, flightBookingRequest);
                setBtnLoading(false);
                if (flightBookingResponse?.status === true) {
                    navigate(`/template/flight-review/${p_adults}/${p_kids}/${p_infants}/${p_isDomestic}`,
                        { state: { flightBookingResponse } });
                } else {
                    alert(flightBookingResponse?.message || "Request flight is not available. Try different flight");
                }
            } catch (error) {
                setBtnLoading(false);
                alert("An error occurred while communicating with the server. Please try again.");
                console.error(error);
            }

        } else {
            setBtnLoading(false);
            alert("Please enter travelers data properly");
        }
    };


    function getTimeFromMins(mins) {
        var h = mins / 60 | 0, m = mins % 60 | 0;
        return h + "h " + m + "m";
    }

    const handleConfirmBooking = () => setShowBookingModal(true);

    const handleContinueBooking = () => {
        setShowBookingModal(false);
        handleSubmit(new Event('submit'));
    };

    const handleBack = () => {
        if (mode === "builder") onNavigate({ name: "flight-results" });
        else navigate(-1);
    };

    useEffect(() => {
        if (!pageState?.searchQuery || !params) {
            if (mode === "builder") onNavigate({ name: "flight-search" });
            else navigate('/template/flight-search');
            return;
        }

        const today = new Date().toISOString().split('T')[0];
        setMinDate(today);
        setSearchQuery(pageState.searchQuery);
        setItinerary(pageState.payload);

        const itineraryData = pageState.payload;
        if(itineraryData) {
            setBaseFare(Object.values(itineraryData).reduce((sum, sf) => sum + (sf.fare?.basePrice || 0), 0).toFixed(2));
            setTax(Object.values(itineraryData).reduce((sum, sf) => sum + (sf.fare?.tax || 0), 0).toFixed(2));
            setTotalFare(Object.values(itineraryData).reduce((sum, sf) => sum + (sf.fare?.totalFare || 0), 0).toFixed(2));
            setTotalPrice(Object.values(itineraryData).reduce((sum, sf) => sum + (sf.fare?.totalPrice || 0), 0).toFixed(2));
            setConvenienceFee(Object.values(itineraryData).reduce((sum, sf) => sum + (sf.fare?.convenienceFee || 0), 0).toFixed(2));
            setPaymentGatewayFee(Object.values(itineraryData).reduce((sum, sf) => sum + (sf.fare?.paymentGatewayFee || 0), 0).toFixed(2));
            setPaymentGatewayAmount(Object.values(itineraryData).reduce((sum, sf) => sum + (sf.fare?.paymentGatewayAmount || 0), 0).toFixed(2));
            setTotalTravellers(p_adults + p_kids + p_infants);

            const filteredFlights = pageState.payload.map(item => {
                const { dcPriceDetails, ...rest } = item.flightLeg;
                return rest;
            });
            setLegs(filteredFlights);
        }

        setAdultTravellers(Array(p_adults).fill().map(() => ({ title: "Mr", firstName: "", lastName: "", type: "ADULT", dateOfBirth: "", passportNo: "", passportNationality: "IN", passbookIssueDate: "", passbookExpireDate: "" })));
        setKidTravellers(Array(p_kids).fill().map(() => ({ title: "Master", firstName: "", lastName: "", type: "CHILD", dateOfBirth: "", passportNo: "", passportNationality: "IN", passbookIssueDate: "", passbookExpireDate: "" })));
        setInfantTravellers(Array(p_infants).fill().map(() => ({ title: "Master", firstName: "", lastName: "", type: "INFANT", dateOfBirth: "", passportNo: "", passportNationality: "IN", passbookIssueDate: "", passbookExpireDate: "" })));

    },[user, loading, pageState, params, navigate, mode]);

    if (loading) return <p style={{color: 'white', padding: 20}}>Loading...</p>;
    if (!user) return null;

    const totalTaxes = (parseFloat(tax) + parseFloat(convenienceFee) + parseFloat(paymentGatewayAmount)).toFixed(2);

    return (
        <div className={styles.page} style={themeVariables}>
            
            {/* Breadcrumb top bar */}
            <div className={styles.topBar}>
                <div className={styles.topBarInner}>
                    <div className={styles.steps}>
                        <div className={styles.step}>
                            <div className={`${styles.stepNum} ${styles.stepNumDone}`}>✓</div>
                            <span className={`${styles.stepLabel} ${styles.stepLabelDone}`}>Select Flight</span>
                        </div>
                        <div className={styles.stepArrow} />
                        <div className={styles.step}>
                            <div className={`${styles.stepNum} ${styles.stepNumActive}`}>2</div>
                            <span className={`${styles.stepLabel} ${styles.stepLabelActive}`}>Confirm Details</span>
                        </div>
                        <div className={styles.stepArrow} />
                        <div className={styles.step}>
                            <div className={styles.stepNum}>3</div>
                            <span className={styles.stepLabel}>Review & Pay</span>
                        </div>
                    </div>
                    <div className={styles.topBarSpacer} />
                    <button className={styles.backBtn} onClick={handleBack}>← Back</button>
                </div>
            </div>

            {/* TWO COLUMN LAYOUT */}
            <div className={styles.main}>

                {/* LEFT COLUMN */}
                <div className={styles.leftCol}>

                    {/* Flight Cards */}
                    {itinerary.length > 0 && itinerary.map((it, idx) => (
                        it.flightLeg?.dcDisplayLegs?.length > 0 && it.flightLeg.dcDisplayLegs.map((leg, index) => {
                            const stops = leg.stops || 0;
                            const stopClass = stops === 0 ? styles.stopGreen : stops === 1 ? styles.stopAmber : styles.stopRed;
                            const stopLabel = stops === 0 ? "Non Stop" : stops === 1 ? "1 Stop" : stops + " Stops";
                            const isRefundable = it.flightLeg?.refundable === "Refundable" || it.fare?.dcAdults?.refundable === "Refundable";
                            return (
                                <div className={styles.flightCard} key={`${idx}-${index}`}>
                                    <div className={styles.flightCardHeader}>
                                        <div className={styles.flightRoute}>
                                            <span className={styles.flightRouteCity}>{leg.startSegment.city}, {leg.startSegment.airportCode}</span>
                                            <span className={styles.flightRouteArrow}>➝</span>
                                            <span className={styles.flightRouteCity}>{leg.endSegment.city}, {leg.endSegment.airportCode}</span>
                                            <span className={styles.flightDatePill}>
                                                📅 {moment(leg.startSegment.departureDateTime).format('DD MMM YY')}
                                            </span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                            <span className={`${styles.refundBadge} ${isRefundable ? styles.refundGreen : styles.refundRed}`}>
                                                {isRefundable ? '✓ REFUNDABLE' : '✕ NON-REFUNDABLE'}
                                            </span>
                                            <button
                                                className={styles.detailsLink}
                                                onClick={() => handleShowFlightDetails(it, leg, idx, index)}
                                            >
                                                Details
                                            </button>
                                        </div>
                                    </div>
                                    <div className={styles.flightCardBody}>
                                        <div className={styles.airlineBlock}>
                                            <div className={styles.airlineLogo}>
                                                <img
                                                    src={`/assets/images/airlinelogos/${leg.airlineData.airlineCode}.png`}
                                                    alt={leg.airlineData.airlineCode}
                                                    className={styles.airlineLogoImg}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.style.display = 'none';
                                                        e.target.parentNode.innerHTML = leg.airlineData.airlineCode;
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <div className={styles.airlineName}>{leg?.airlineData?.airline}</div>
                                                <div className={styles.flightNum}>{leg?.airlineData?.airlineCode}-{leg?.airlineData?.flightNumber}</div>
                                            </div>
                                        </div>
                                        <div className={styles.routeTrack}>
                                            <div className={styles.timeBlock}>
                                                <div className={styles.timeMain}>{moment(leg?.startSegment?.departureDateTime).format("HH:mm")}</div>
                                                <div className={styles.timeApt}>{leg?.startSegment?.airportCode}</div>
                                                <div className={styles.timeDate}>{moment(leg?.startSegment?.departureDateTime).format("DD MMM YY")}</div>
                                            </div>
                                            <div className={styles.durationBlock}>
                                                <div className={styles.durationText}>{getTimeFromMins(leg?.totalDuration)}</div>
                                                <div className={styles.trackLine}>
                                                    <div className={styles.trackDot} />
                                                    <div className={styles.trackBar} />
                                                    <div className={styles.trackDot} />
                                                </div>
                                                <span className={`${styles.stopBadge} ${stopClass}`}>{stopLabel}</span>
                                            </div>
                                            <div className={styles.timeBlock}>
                                                <div className={styles.timeMain}>{moment(leg?.endSegment?.arrivalDateTime).format("HH:mm")}</div>
                                                <div className={styles.timeApt}>{leg?.endSegment?.airportCode}</div>
                                                <div className={styles.timeDate}>{moment(leg?.endSegment?.arrivalDateTime).format("DD MMM YY")}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ))}

                    <div className={styles.noteBanner}>
                        <span className={styles.noteTag}>NOTE:</span>
                        <span className={styles.noteText}>This is a special fare given by the airline. Airlines cancellation charges do apply.</span>
                    </div>

                    {/* Traveler Details Section */}
                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionHead}>
                            <span className={styles.sectionHeadIcon}>👥</span>
                            <span className={styles.sectionTitle}>Traveler Details</span>
                        </div>
                        <div className={styles.sectionBody}>

                            <div className={styles.infoBanner}>
                                <div className={styles.infoBannerDot} />
                                <span className={styles.infoBannerText}>Please enter your name exactly as per your passport or PAN card</span>
                            </div>

                            {/* Adults */}
                            {adultTravellers.length > 0 && (
                                <div className={styles.passengerCategory}>
                                    <div className={styles.categoryTitle}>
                                        <span>👔</span> Adults ({adultTravellers.length})
                                    </div>
                                    <div className={styles.passengerGrid}>
                                        {adultTravellers.map((adult, index) => (
                                            <div className={styles.passengerCard} key={`adult-${index}`}>
                                                <div className={styles.passengerCardTitle}>Adult {index + 1}</div>
                                                <div className={styles.fieldsGrid}>
                                                    <div className={styles.fieldGroup}>
                                                        <label className={styles.fieldLabel}>Title</label>
                                                        <select className={styles.fieldSelect} name="title" value={adult.title} onChange={(event) => handleAdultChange(index, event)}>
                                                            <option value="Mr">Mr</option>
                                                            <option value="Mrs">Mrs</option>
                                                            <option value="Ms">Ms</option>
                                                            <option value="Master">Master</option>
                                                        </select>
                                                        {errors.title === false && (<div className={styles.fieldError}>Please select title</div>)}
                                                    </div>
                                                    <div className={styles.fieldGroup}>
                                                        <label className={styles.fieldLabel}>Given Name</label>
                                                        <input className={styles.fieldInput} type="text" name="firstName" value={adult.firstName} onChange={(event) => handleAdultChange(index, event)} placeholder="First Name" />
                                                        {errors.firstName === false && (<div className={styles.fieldError}>Please enter first name</div>)}
                                                    </div>
                                                    <div className={styles.fieldGroup}>
                                                        <label className={styles.fieldLabel}>Surname</label>
                                                        <input className={styles.fieldInput} type="text" name="lastName" value={adult.lastName} onChange={(event) => handleAdultChange(index, event)} placeholder="Last Name" />
                                                        {errors.lastName === false && (<div className={styles.fieldError}>Please enter last name</div>)}
                                                    </div>
                                                    {p_isDomestic === 'INTERNATIONAL' && (
                                                        <div className={styles.fieldGroup}>
                                                            <label className={styles.fieldLabel}>Date of Birth</label>
                                                            <input className={styles.fieldInput} type="date" name="dateOfBirth" value={adult.dateOfBirth} onBlur={(event) => validateAdultDate(index, event)} onChange={(event) => handleAdultChange(index, event)} />
                                                            {errors.dateOfBirth === false && (<div className={styles.fieldError}>Please enter date of birth</div>)}
                                                            {errorAdult && <div className={styles.fieldError}>{errorAdult}</div>}
                                                        </div>
                                                    )}
                                                </div>
                                                {p_isDomestic === 'INTERNATIONAL' && (
                                                    <>
                                                        <div className={styles.passportDivider}>
                                                            <div className={styles.passportDividerLine} />
                                                            <span className={styles.passportDividerLabel}>Passport Details</span>
                                                            <div className={styles.passportDividerLine} />
                                                        </div>
                                                        <div className={styles.fieldsGrid}>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Passport No</label>
                                                                <input className={styles.fieldInput} type="text" name="passportNo" value={adult.passportNo} onChange={(event) => handleAdultChange(index, event)} maxLength="10" placeholder="Passport No" />
                                                                {errors.passportNo === false && (<div className={styles.fieldError}>Please enter passport no</div>)}
                                                            </div>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Nationality</label>
                                                                <select className={styles.fieldSelect} name="passportNationality" value={adult.passportNationality} onChange={(event) => handleAdultChange(index, event)}>
                                                                    {countries.length > 0 && countries.map(cs => (<option key={cs.code} value={cs.code}>{cs.name}</option>))}
                                                                </select>
                                                                {errors.passportNationality === false && (<div className={styles.fieldError}>Please select nationality</div>)}
                                                            </div>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Issue Date</label>
                                                                <input className={styles.fieldInput} type="date" name="passbookIssueDate" value={adult.passbookIssueDate} onChange={(event) => handleAdultChange(index, event)} onBlur={(event) => validatePassportDates("adult", index, event)} />
                                                                {errors.passbookIssueDate === false && (<div className={styles.fieldError}>Please enter issue date</div>)}
                                                                {passportErrors[`adult_${index}_passbookIssueDate`] && (<div className={styles.fieldError}>{passportErrors[`adult_${index}_passbookIssueDate`]}</div>)}
                                                            </div>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Expiry Date</label>
                                                                <input className={styles.fieldInput} type="date" name="passbookExpireDate" value={adult.passbookExpireDate} onChange={(event) => handleAdultChange(index, event)} onBlur={(event) => validatePassportDates("adult", index, event)} min={minDate} />
                                                                {errors.passbookExpireDate === false && (<div className={styles.fieldError}>Please enter expiry date</div>)}
                                                                {passportErrors[`adult_${index}_passbookExpireDate`] && (<div className={styles.fieldError}>{passportErrors[`adult_${index}_passbookExpireDate`]}</div>)}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Children */}
                            {kidTravellers.length > 0 && (
                                <div className={styles.passengerCategory}>
                                    <div className={styles.categoryTitle}>
                                        <span>🧒</span> Children ({kidTravellers.length})
                                    </div>
                                    <div className={styles.passengerGrid}>
                                        {kidTravellers.map((kid, index) => (
                                            <div className={styles.passengerCard} key={`kid-${index}`}>
                                                <div className={styles.passengerCardTitle}>Child {index + 1}</div>
                                                <div className={styles.fieldsGrid}>
                                                    <div className={styles.fieldGroup}>
                                                        <label className={styles.fieldLabel}>Title</label>
                                                        <select className={styles.fieldSelect} name="title" value={kid.title} onChange={(event) => handleKidsChange(index, event)}>
                                                            <option value="Ms">Ms</option>
                                                            <option value="Master">Master</option>
                                                        </select>
                                                        {errors.title === false && (<div className={styles.fieldError}>Please select title</div>)}
                                                    </div>
                                                    <div className={styles.fieldGroup}>
                                                        <label className={styles.fieldLabel}>Given Name</label>
                                                        <input className={styles.fieldInput} type="text" name="firstName" value={kid.firstName} onChange={(event) => handleKidsChange(index, event)} placeholder="First Name" />
                                                        {errors.firstName === false && (<div className={styles.fieldError}>Please enter first name</div>)}
                                                    </div>
                                                    <div className={styles.fieldGroup}>
                                                        <label className={styles.fieldLabel}>Surname</label>
                                                        <input className={styles.fieldInput} type="text" name="lastName" value={kid.lastName} onChange={(event) => handleKidsChange(index, event)} placeholder="Last Name" />
                                                        {errors.lastName === false && (<div className={styles.fieldError}>Please enter last name</div>)}
                                                    </div>
                                                    {p_isDomestic === 'INTERNATIONAL' && (
                                                        <div className={styles.fieldGroup}>
                                                            <label className={styles.fieldLabel}>Date of Birth</label>
                                                            <input className={styles.fieldInput} type="date" name="dateOfBirth" value={kid.dateOfBirth} onBlur={(event) => validateKidsDate(index, event)} onChange={(event) => handleKidsChange(index, event)} />
                                                            {errors.dateOfBirth === false && (<div className={styles.fieldError}>Please enter date of birth</div>)}
                                                            {errorKid && <div className={styles.fieldError}>{errorKid}</div>}
                                                        </div>
                                                    )}
                                                </div>
                                                {p_isDomestic === 'INTERNATIONAL' && (
                                                    <>
                                                        <div className={styles.passportDivider}>
                                                            <div className={styles.passportDividerLine} />
                                                            <span className={styles.passportDividerLabel}>Passport Details</span>
                                                            <div className={styles.passportDividerLine} />
                                                        </div>
                                                        <div className={styles.fieldsGrid}>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Passport No</label>
                                                                <input className={styles.fieldInput} type="text" name="passportNo" value={kid.passportNo} onChange={(event) => handleKidsChange(index, event)} maxLength="10" placeholder="Passport No" />
                                                                {errors.passportNo === false && (<div className={styles.fieldError}>Please enter passport no</div>)}
                                                            </div>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Nationality</label>
                                                                <select className={styles.fieldSelect} name="passportNationality" value={kid.passportNationality} onChange={(event) => handleKidsChange(index, event)}>
                                                                    {countries.length > 0 && countries.map(cs => (<option key={cs.code} value={cs.code}>{cs.name}</option>))}
                                                                </select>
                                                                {errors.passportNationality === false && (<div className={styles.fieldError}>Please select nationality</div>)}
                                                            </div>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Issue Date</label>
                                                                <input className={styles.fieldInput} type="date" name="passbookIssueDate" value={kid.passbookIssueDate} onChange={(event) => handleKidsChange(index, event)} onBlur={(event) => validatePassportDates("kid", index, event)} />
                                                                {errors.passbookIssueDate === false && (<div className={styles.fieldError}>Please enter issue date</div>)}
                                                                {passportErrors[`kid_${index}_passbookIssueDate`] && (<div className={styles.fieldError}>{passportErrors[`kid_${index}_passbookIssueDate`]}</div>)}
                                                            </div>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Expiry Date</label>
                                                                <input className={styles.fieldInput} type="date" name="passbookExpireDate" value={kid.passbookExpireDate} onChange={(event) => handleKidsChange(index, event)} onBlur={(event) => validatePassportDates("kid", index, event)} min={minDate} />
                                                                {errors.passbookExpireDate === false && (<div className={styles.fieldError}>Please enter expiry date</div>)}
                                                                {passportErrors[`kid_${index}_passbookExpireDate`] && (<div className={styles.fieldError}>{passportErrors[`kid_${index}_passbookExpireDate`]}</div>)}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Infants */}
                            {infantTravellers.length > 0 && (
                                <div className={styles.passengerCategory}>
                                    <div className={styles.categoryTitle}>
                                        <span>👶</span> Infants ({infantTravellers.length})
                                    </div>
                                    <div className={styles.passengerGrid}>
                                        {infantTravellers.map((infant, index) => (
                                            <div className={styles.passengerCard} key={`infant-${index}`}>
                                                <div className={styles.passengerCardTitle}>Infant {index + 1}</div>
                                                <div className={styles.fieldsGrid}>
                                                    <div className={styles.fieldGroup}>
                                                        <label className={styles.fieldLabel}>Title</label>
                                                        <select className={styles.fieldSelect} name="title" value={infant.title} onChange={(event) => handleInfantChange(index, event)}>
                                                            <option value="Ms">Ms</option>
                                                            <option value="Master">Master</option>
                                                        </select>
                                                        {errors.title === false && (<div className={styles.fieldError}>Please select title</div>)}
                                                    </div>
                                                    <div className={styles.fieldGroup}>
                                                        <label className={styles.fieldLabel}>Given Name</label>
                                                        <input className={styles.fieldInput} type="text" name="firstName" value={infant.firstName} onChange={(event) => handleInfantChange(index, event)} placeholder="First Name" />
                                                        {errors.firstName === false && (<div className={styles.fieldError}>Please enter first name</div>)}
                                                    </div>
                                                    <div className={styles.fieldGroup}>
                                                        <label className={styles.fieldLabel}>Surname</label>
                                                        <input className={styles.fieldInput} type="text" name="lastName" value={infant.lastName} onChange={(event) => handleInfantChange(index, event)} placeholder="Last Name" />
                                                        {errors.lastName === false && (<div className={styles.fieldError}>Please enter last name</div>)}
                                                    </div>
                                                    {p_isDomestic === 'INTERNATIONAL' && (
                                                        <div className={styles.fieldGroup}>
                                                            <label className={styles.fieldLabel}>Date of Birth</label>
                                                            <input className={styles.fieldInput} type="date" name="dateOfBirth" value={infant.dateOfBirth} onBlur={(event) => validateInfantDate(index, event)} onChange={(event) => handleInfantChange(index, event)} />
                                                            {errors.dateOfBirth === false && (<div className={styles.fieldError}>Please enter date of birth</div>)}
                                                            {errorInfant && <div className={styles.fieldError}>{errorInfant}</div>}
                                                        </div>
                                                    )}
                                                </div>
                                                {p_isDomestic === 'INTERNATIONAL' && (
                                                    <>
                                                        <div className={styles.passportDivider}>
                                                            <div className={styles.passportDividerLine} />
                                                            <span className={styles.passportDividerLabel}>Passport Details</span>
                                                            <div className={styles.passportDividerLine} />
                                                        </div>
                                                        <div className={styles.fieldsGrid}>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Passport No</label>
                                                                <input className={styles.fieldInput} type="text" name="passportNo" value={infant.passportNo} onChange={(event) => handleInfantChange(index, event)} maxLength="10" placeholder="Passport No" />
                                                                {errors.passportNo === false && (<div className={styles.fieldError}>Please enter passport no</div>)}
                                                            </div>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Nationality</label>
                                                                <select className={styles.fieldSelect} name="passportNationality" value={infant.passportNationality} onChange={(event) => handleInfantChange(index, event)}>
                                                                    {countries.length > 0 && countries.map(cs => (<option key={cs.code} value={cs.code}>{cs.name}</option>))}
                                                                </select>
                                                                {errors.passportNationality === false && (<div className={styles.fieldError}>Please select nationality</div>)}
                                                            </div>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Issue Date</label>
                                                                <input className={styles.fieldInput} type="date" name="passbookIssueDate" value={infant.passbookIssueDate} onChange={(event) => handleInfantChange(index, event)} onBlur={(event) => validatePassportDates("infant", index, event)} />
                                                                {errors.passbookIssueDate === false && (<div className={styles.fieldError}>Please enter issue date</div>)}
                                                                {passportErrors[`infant_${index}_passbookIssueDate`] && (<div className={styles.fieldError}>{passportErrors[`infant_${index}_passbookIssueDate`]}</div>)}
                                                            </div>
                                                            <div className={styles.fieldGroup}>
                                                                <label className={styles.fieldLabel}>Expiry Date</label>
                                                                <input className={styles.fieldInput} type="date" name="passbookExpireDate" value={infant.passbookExpireDate} onChange={(event) => handleInfantChange(index, event)} onBlur={(event) => validatePassportDates("infant", index, event)} min={minDate} />
                                                                {errors.passbookExpireDate === false && (<div className={styles.fieldError}>Please enter expiry date</div>)}
                                                                {passportErrors[`infant_${index}_passbookExpireDate`] && (<div className={styles.fieldError}>{passportErrors[`infant_${index}_passbookExpireDate`]}</div>)}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Contact Information */}
                            <div className={styles.sectionHead} style={{marginTop: 20}}>
                                <span className={styles.sectionHeadIcon}>📞</span>
                                <span className={styles.sectionTitle}>Contact Information</span>
                            </div>
                            <div className={styles.contactGrid}>
                                <div className={styles.fieldGroup}>
                                    <label className={styles.fieldLabel}>Email Address</label>
                                    <input className={styles.fieldInput} type="text" maxLength={45} value={email} name="email" onChange={handleEmailChange} placeholder="Email Here" />
                                    {errors.email === false && (<div className={styles.fieldError}>Please enter email</div>)}
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label className={styles.fieldLabel}>Mobile number</label>
                                    <input className={styles.fieldInput} type="text" maxLength={12} value={mobile} name="mobile" onChange={handleMobileChange} placeholder="Mobile Number" />
                                    {errors.mobile === false && (<div className={styles.fieldError}>Please enter mobile</div>)}
                                </div>
                            </div>

                            {/* GST Information */}
                            <div className={styles.sectionHead} style={{marginTop: 20}}>
                                <span className={styles.sectionHeadIcon}>🧾</span>
                                <span className={styles.sectionTitle}>GST Information <span style={{ fontSize: '0.65rem', opacity: 0.4, fontWeight: 500 }}>(optional)</span></span>
                            </div>
                            <div className={styles.gstGrid}>
                                <div className={styles.fieldGroup}>
                                    <label className={styles.fieldLabel}>GST Number</label>
                                    <input className={styles.fieldInput} type="text" value={companyGST} onChange={(e) => setCompanyGST(e.target.value)} placeholder="Company GST Number" maxLength="25" />
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label className={styles.fieldLabel}>Registered Company Name</label>
                                    <input className={styles.fieldInput} type="text" value={companyName} onChange={(e) => setCompanyName(e.target.value)} placeholder="Company Name" maxLength="100" />
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label className={styles.fieldLabel}>Company Address</label>
                                    <input className={styles.fieldInput} type="text" value={companyAddress} onChange={(e) => setCompanyAddress(e.target.value)} placeholder="Company Address" />
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className={styles.actionBar} style={{marginTop: 30}}>
                                <button className={styles.btnSecondary} onClick={handleBack}>Back</button>
                                <button className={styles.btnPrimary} onClick={handleConfirmBooking} disabled={btnLoading}>
                                    {btnLoading ? 'Processing...' : 'Confirm Booking'}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

                {/* RIGHT COLUMN — Fare Details */}
                <div className={styles.rightCol}>
                    <div className={styles.fareCard}>
                        <div className={styles.fareCardHead}>
                            <span className={styles.fareCardHeadIcon}>🧾</span>
                            <span className={styles.fareCardTitle}>Fare Details</span>
                        </div>
                        <div className={styles.fareCardBody}>
                            <div className={styles.fareRow}>
                                <span className={styles.fareRowLabel}>Base Fare</span>
                                <span className={styles.fareRowVal}>INR {baseFare}</span>
                            </div>
                            <div className={styles.fareRow}>
                                <span className={styles.fareRowLabel}>Taxes &amp; Fees</span>
                                <span className={styles.fareRowVal}>INR {totalTaxes}</span>
                            </div>
                            <div className={styles.fareTotalBlock}>
                                <span className={styles.fareTotalLabel}>Total Amount</span>
                                <span className={styles.fareTotalAmount}>
                                    <span className={styles.fareTotalCurrency}>INR</span> {totalPrice}
                                </span>
                            </div>
                            <div className={styles.paxPill}>
                                <span className={styles.paxPillIcon}>👥</span> Adult : {p_adults}, Child : {p_kids}, Infant : {p_infants}
                            </div>
                            <div className={styles.fareNote}>
                                <span className={styles.fareNoteIcon}>ℹ️</span> Cancellation charges apply as per airline policy
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* Flight Details Modal */}
            {showFlightModal && selectedFlightDetails && (
                <div className={styles.modalOverlay} onClick={() => setShowFlightModal(false)}>
                    <div className={`${styles.modal} ${styles.modalLg}`} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.modalHead}>
                            <span className={styles.modalTitle}>
                                Flight Details - {selectedFlightDetails.leg.airlineData.flightNumber} · {selectedFlightDetails.leg.airlineData.airline}
                            </span>
                            <button className={styles.modalClose} onClick={() => setShowFlightModal(false)}>&times;</button>
                        </div>
                        <div className={styles.modalBody}>
                            <div className={styles.modalTabs}>
                                <button
                                    className={`${styles.modalTab} ${activeTab[selectedFlightDetails.modalId] === 'flight' || !activeTab[selectedFlightDetails.modalId] ? styles.modalTabActive : ''}`}
                                    onClick={() => handleTabClick(selectedFlightDetails.modalId, 'flight')}>
                                    Flight Details
                                </button>
                                <button
                                    className={`${styles.modalTab} ${activeTab[selectedFlightDetails.modalId] === 'baggage' ? styles.modalTabActive : ''}`}
                                    onClick={() => handleTabClick(selectedFlightDetails.modalId, 'baggage')}>
                                    Baggage Details
                                </button>
                                <button
                                    className={`${styles.modalTab} ${activeTab[selectedFlightDetails.modalId] === 'cancel' ? styles.modalTabActive : ''}`}
                                    onClick={() => handleTabClick(selectedFlightDetails.modalId, 'cancel')}>
                                    Cancellation Fee
                                </button>
                            </div>

                            {(!activeTab[selectedFlightDetails.modalId] || activeTab[selectedFlightDetails.modalId] === 'flight') && (
                                <div>
                                    {selectedFlightDetails.itinerary.flightLeg?.dcSegments?.map((seg, segIdx) => (
                                        <React.Fragment key={segIdx}>
                                            <div className={styles.segmentRow}>
                                                <div className={styles.segAirline}>
                                                    <div className={styles.segAirlineLogo}>
                                                        <img
                                                            src={`/assets/images/airlinelogos/${seg.tFAirlineData?.airlineCode}.png`}
                                                            alt={seg.tFAirlineData?.airlineCode}
                                                            style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.style.display = 'none';
                                                                e.target.parentNode.innerHTML = seg.tFAirlineData?.airlineCode;
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div className={styles.segAirlineName}>{seg.tFAirlineData?.airline}</div>
                                                        <div className={styles.segFlightNum}>{seg.tFAirlineData?.flightNumber}</div>
                                                    </div>
                                                </div>
                                                <div className={styles.segTimeBlock}>
                                                    <div className={styles.segTime}>{moment(seg.tFDepartureData.departureDateTime).format('HH:mm')}</div>
                                                    <div className={styles.segApt}>{seg.tFDepartureData.airportCode}{seg.tFDepartureData.terminal && ` · T${seg.tFDepartureData.terminal}`}</div>
                                                </div>
                                                <div className={styles.segArrow}>→</div>
                                                <div className={styles.segTimeBlock}>
                                                    <div className={styles.segTime}>{moment(seg.tFArrivalData.arrivalDateTime).format('HH:mm')}</div>
                                                    <div className={styles.segApt}>{seg.tFArrivalData.airportCode}{seg.tFArrivalData.terminal && ` · T${seg.tFArrivalData.terminal}`}</div>
                                                </div>
                                                <div className={styles.segDuration}>{getTimeFromMins(seg.tFAirlineData?.duration)}</div>
                                            </div>
                                            {seg.tFAirlineData?.connectingTime !== 0 && segIdx < selectedFlightDetails.itinerary.flightLeg.dcSegments.length - 1 && (
                                                <div className={styles.layoverPill}>
                                                    🕐 Layover: {getTimeFromMins(seg.tFAirlineData?.connectingTime)}
                                                </div>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>
                            )}

                            {activeTab[selectedFlightDetails.modalId] === 'baggage' && (
                                <div>
                                    <table className={styles.baggageTable}>
                                        <thead>
                                            <tr><th></th><th>Cabin</th><th>Check-In</th></tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Adult</td>
                                                <td>{selectedFlightDetails.itinerary.fare?.dcAdults?.cabinBag || '7 Kg'}</td>
                                                <td>{selectedFlightDetails.itinerary.fare?.dcAdults?.checkinBag || '20 Kg'}</td>
                                            </tr>
                                            <tr>
                                                <td>Child</td>
                                                <td>{selectedFlightDetails.itinerary.fare?.dcKids?.cabinBag || '7 Kg'}</td>
                                                <td>{selectedFlightDetails.itinerary.fare?.dcKids?.checkinBag || '20 Kg'}</td>
                                            </tr>
                                            <tr>
                                                <td>Infant</td>
                                                <td>{selectedFlightDetails.itinerary.fare?.dcInfants?.cabinBag || '0 Kg'}</td>
                                                <td>{selectedFlightDetails.itinerary.fare?.dcInfants?.checkinBag || '0 Kg'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {activeTab[selectedFlightDetails.modalId] === 'cancel' && (
                                <div>
                                    <ul className={styles.cancelList}>
                                        <li className={styles.cancelListItem}><div className={styles.cancelDot} />The penalty is subject before departure. No Changes are allowed after that.</li>
                                        <li className={styles.cancelListItem}><div className={styles.cancelDot} />The charges are per passenger per sector.</li>
                                        <li className={styles.cancelListItem}><div className={styles.cancelDot} />Partial cancellation is not allowed on tickets booked under special discounted fares.</li>
                                        <li className={styles.cancelListItem}><div className={styles.cancelDot} />In case of no-show or ticket not cancelled within the stipulated time, only statutory taxes are refundable subject to Service Fee.</li>
                                        <li className={styles.cancelListItem}><div className={styles.cancelDot} />No Baggage Allowance for Infants</li>
                                        <li className={styles.cancelListItem}><div className={styles.cancelDot} />Airline penalty needs to be reconfirmed prior to any amendments or cancellation.</li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Booking Confirmation Modal */}
            {showBookingModal && (
                <div className={styles.modalOverlay} onClick={() => setShowBookingModal(false)}>
                    <div className={`${styles.modal} ${styles.modalSm}`} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.modalHead}>
                            <span className={styles.modalTitle}>Confirm Booking</span>
                            <button className={styles.modalClose} onClick={() => setShowBookingModal(false)}>&times;</button>
                        </div>
                        <div className={styles.modalBody}>
                            <div className={styles.confirmSummary}>
                                <div className={styles.confirmRow}>
                                    <span className={styles.confirmRowLabel}>Flight:</span>
                                    <span className={styles.confirmRowVal}>
                                        {itinerary.map((it, idx) => (
                                            <span key={idx}>
                                                {it.flightLeg?.dcDisplayLegs[0]?.airlineData?.flightNumber}
                                                {idx < itinerary.length - 1 ? ' & ' : ''}
                                            </span>
                                        ))}
                                    </span>
                                </div>
                                <div className={styles.confirmRow}>
                                    <span className={styles.confirmRowLabel}>Passengers:</span>
                                    <span className={styles.confirmRowVal}>
                                        {p_adults} Adult{p_adults > 1 ? 's' : ''}, {p_kids} Child{p_kids > 1 ? 'ren' : ''}, {p_infants} Infant{p_infants > 1 ? 's' : ''}
                                    </span>
                                </div>
                                <div className={styles.confirmRow}>
                                    <span className={styles.confirmRowLabel}>Total Amount:</span>
                                    <span className={styles.confirmRowGold}>INR {totalPrice}</span>
                                </div>
                            </div>
                            <div className={styles.confirmActions}>
                                <button className={styles.btnPrimary} onClick={handleContinueBooking} disabled={btnLoading}>
                                    {btnLoading ? 'Processing...' : 'Continue Booking'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FlightDetails2;